import React from 'react'
import { FacetFilterGroup } from 'types/form'
import LocalizedSelectInput from 'ui-shared/LocalizedFields/LocalizedSelectInput'
import { FacetSelectComponentProps, SingleSelectableFacetCategory } from '..'
import useFacets from './useFacets'

type SinglePickListFacetCategory = Extract<
  SingleSelectableFacetCategory,
  'group' | 'productFilter'
>

type SinglePickListFacetFilterGroup = Extract<
  FacetFilterGroup,
  'TeamBuildingCategory' | 'Skill' | 'VirtualCategory' | 'Type' | 'Location'
>

type Props = FacetSelectComponentProps<
  SinglePickListFacetCategory,
  SinglePickListFacetFilterGroup
>

/**
 * We use this component for Drink, Group and productFilter facets.
 * In case of Drink or Group facets we just need to pass facetCategory prop as string.
 * In case of productFilter facets, we need to specify as well the filterGroup, since productFilter facets are used for different products.
 */
export const FacetSelect: React.FC<Props> = ({
  facetCategory,
  source,
  filterGroup,
}) => {
  const facets = useFacets(facetCategory, filterGroup)
  if (!facets.length) return null

  return (
    <LocalizedSelectInput
      label={`form.fields.${source}`}
      optionText="description"
      fullWidth
      resettable
      source={source}
      choices={facets}
    />
  )
}
